

export const plans = [
    {
        name: "3 Months",
        price: "29.99",
        features: [
            "1000+ chaînes",
            "Qualité HD",
            'Instant VOD Access',

            "1 appareil simultanément",
            "Smart EPG & Catch-Up TV",
            'Multi-Device Compatibility',

        ],
        highlighted: false,
    },
    {
        name: "1 ans ",
        price: "45.99",
        features: [
            "5000+ chaînes",
            "Qualité 4K",
            'Instant VOD Access',
            "1 appareil simultanément",
            "Support prioritaire",
            "Smart EPG & Catch-Up TV",
            'Multi-Device Compatibility',

        ],
        highlighted: false,
    },
    {
        name: "1 ans",
        app: "Appareils illimités",
        price: "99.99",
        features: [
            "5000+ chaînes",
            "Qualité 4K",
            'Instant VOD Access',

            "ilemité des Appareils illimités",
            "Support 24/7",
            "Smart EPG & Catch-Up TV",
            'Multi-Device Compatibility',

        ],
        highlighted: true,
    },
    {
        name: "6 Month ",
        price: "40.99",
        features: [
            "5000+ chaînes",
            "Qualité 4K",
            'Instant VOD Access',
            "1 appareil simultanément",
            "Support 24/7",
            "Smart EPG & Catch-Up TV",
            'Multi-Device Compatibility',

        ],
        highlighted: false,
    },
    
];